import {
    SELECT_REPORT,
    SET_ALL_REPORTS,
    SET_UUID_REPORT
} from '../types/reportsTypes';

const initialState = {
    all: [],
    selected: {},
    selectedUuid:null
};

const reportsReducer = (state = initialState, action) => {
    switch (action.type) {
        case SET_ALL_REPORTS:
            return { ...state, all: action.payload };
        case SELECT_REPORT:
            return { ...state, selected: action.payload };
            case SET_UUID_REPORT:
                return { ...state,selectedUuid:action.payload };
        default:
            return state;
    }
}

export default reportsReducer